import React, { useEffect, useState } from "react";

import PlacaTexto from "./PlacaTexto";

const TIQUE_MS = 20;
const REPOUSO_MS = 7000;
// tiques de folga entre o fim do número e o começo da frase, para a onda ler
// como um único movimento atravessando a linha
const FOLGA = 3;

/**
 * A troca acontece em duas etapas: uma onda apaga o texto atual da esquerda
 * para a direita e outra escreve o próximo. Na virada entre as etapas a linha
 * está vazia, e é por isso que a mudança de geometria entre uma frase e a
 * seguinte não é percebida.
 */
const TituloPlaca = ({ variacoes }) => {
  const [indice, setIndice] = useState(0);
  const [fase, setFase] = useState("entrando");
  const [tique, setTique] = useState(0);

  const atual = variacoes[indice];
  const atrasoFrase = [...atual.numero].length + FOLGA;
  const ultimoTique = atrasoFrase + [...atual.frase].length;

  useEffect(() => {
    if (fase === "parado") return undefined;

    if (tique <= ultimoTique) {
      const cronometro = setTimeout(() => setTique((valor) => valor + 1), TIQUE_MS);
      return () => clearTimeout(cronometro);
    }

    if (fase === "saindo") {
      setIndice((valor) => (valor + 1) % variacoes.length);
      setFase("entrando");
      setTique(0);
      return undefined;
    }

    setFase("parado");
    return undefined;
  }, [fase, tique, ultimoTique, variacoes.length]);

  useEffect(() => {
    if (fase !== "parado") return undefined;
    const cronometro = setTimeout(() => {
      setFase("saindo");
      setTique(0);
    }, REPOUSO_MS);
    return () => clearTimeout(cronometro);
  }, [fase]);

  return (
    <h1 className="titulo" aria-label={`${atual.numero} dos brasileiros ${atual.frase}`}>
      {/* as três variações ficam no DOM como medida invisível, em células como
          a camada animada, para que altura e quebra de linha coincidam */}
      {variacoes.map((variacao) => (
        <span className="titulo-medida" key={variacao.numero} aria-hidden="true">
          <span className="numero">
            <PlacaTexto texto={variacao.numero} />
          </span>{" "}
          dos brasileiros <PlacaTexto texto={variacao.frase} />
        </span>
      ))}

      <span className="titulo-ativo" aria-hidden="true">
        <span className="numero">
          <PlacaTexto texto={atual.numero} fase={fase} tique={tique} />
        </span>{" "}
        dos brasileiros{" "}
        <PlacaTexto texto={atual.frase} fase={fase} tique={tique} atraso={atrasoFrase} />
      </span>
    </h1>
  );
};

export default TituloPlaca;
